export default __webpack_public_path__ + "static/media/international.0e82d8e8.svg";